export default (that = {}) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('INDEX.order_goods_label_orderGoodsNo') || '产品编号',
    field: 'orderGoodsNo',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_identifyGoodsNo') || '产品识别编号',
    field: 'identifyGoodsNo',
    minWidth: 200,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_orderGoodsDisplayName') || '产品名称',
    field: 'orderGoodsDisplayName',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_inPackageQty') || '装箱入数',
    field: 'inPackageQty',
    minWidth: 140,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  }
]
